import { render, staticRenderFns } from "./course-area-inspection.vue?vue&type=template&id=75dbe38f&scoped=true&"
import script from "./course-area-inspection.vue?vue&type=script&lang=js&"
export * from "./course-area-inspection.vue?vue&type=script&lang=js&"
import style0 from "./course-area-inspection.vue?vue&type=style&index=0&id=75dbe38f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dbe38f",
  null
  
)

export default component.exports